/* Native details retain readable content when JavaScript is unavailable. */
if (!customElements.get('pt-home-brand-story')) {
  customElements.define('pt-home-brand-story', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.updateLayout = () => { this.details.open = !this.mobile.matches; };
      this.updateLayout();
      this.mobile.addEventListener('change', this.updateLayout);
    }
    disconnectedCallback() {
      if (this.mobile) this.mobile.removeEventListener('change', this.updateLayout);
    }
  });
}
